import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import ResponsiveSidebar from "./ResponsiveSidebar";

export default function PrivateRoute({ children, withSidebar = true }) {
  const { user } = useUser();

  if (user === undefined) return null; // Loading state
  if (!user) return <Navigate to="/login" replace />;

  return withSidebar ? (
    <ResponsiveSidebar>{children}</ResponsiveSidebar>
  ) : (
    children
  );
}
